module.exports = __webpack_public_path__ + "static/media/Holiday Elf (Series 23).1a7b51b6.jpg";